// theme constant
export const gridSpacing = 5;
export const gridSpacingCaja = 1;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const gridSpacing2 = 2;
